import {
  BlockType,
  ColorSchemeSchema,
  FieldGroupSchema,
  FieldRole,
  ImageFieldSchema,
  ImageSizeFieldSchema,
  RichTextFieldSchema,
  UrlFieldSchema,
} from './Types';
import { z } from 'zod';

export enum TestimonialLayout {
  ImageRight = 'imageRight',
  ImageLeft = 'imageLeft',
  ImageTop = 'imageTop',
  HideImage = 'hideImage',
}

const TestimonialLayoutSchema = z.nativeEnum(TestimonialLayout);

const TestimonialBodyFieldSchema = RichTextFieldSchema.extend({
  name: z.literal('body'),
  role: z.literal(FieldRole.Body),
});

const TestimonialCtaTextFieldSchema = RichTextFieldSchema.extend({
  name: z.literal('ctaText'),
  role: z.literal(FieldRole.CtaText),
});

const TestimonialCtaUrlFieldSchema = UrlFieldSchema.extend({
  name: z.literal('ctaUrl'),
  role: z.literal(FieldRole.CtaUrl),
});

const TestimonialPreheaderFieldSchema = RichTextFieldSchema.extend({
  name: z.literal('preheader'),
  role: z.literal(FieldRole.Preheader),
});

const TestimonialHeaderLogoFieldSchema = ImageFieldSchema.extend({
  name: z.literal('headerLogo'),
  role: z.literal(FieldRole.Logo),
});

const TestimonialHeaderLogoSizeFieldSchema = ImageSizeFieldSchema.extend({
  name: z.literal('headerLogoSize'),
  role: z.literal(FieldRole.Logo),
});

const TestimonialHeaderTextFieldSchema = RichTextFieldSchema.extend({
  name: z.literal('headerText'),
  role: z.literal(FieldRole.Header),
});

const TestimonialImageFieldSchema = ImageFieldSchema.extend({
  name: z.literal('image'),
  role: z.literal(FieldRole.Image),
});

const TestimonialNameCreditFieldSchema = RichTextFieldSchema.extend({
  name: z.literal('nameCredit'),
  role: z.literal(FieldRole.NameCredit),
});

const TestimonialFieldSchema = z.discriminatedUnion('name', [
  TestimonialBodyFieldSchema,
  TestimonialCtaTextFieldSchema,
  TestimonialCtaUrlFieldSchema,
  TestimonialPreheaderFieldSchema,
  TestimonialHeaderLogoFieldSchema,
  TestimonialHeaderLogoSizeFieldSchema,
  TestimonialHeaderTextFieldSchema,
  TestimonialImageFieldSchema,
  TestimonialNameCreditFieldSchema,
]);

const TestimonialFieldGroupSchema = FieldGroupSchema.merge(
  z.object({
    fields: z.array(TestimonialFieldSchema),
  }),
);

const TestimonialOptionsSchema = z.object({
  colorScheme: ColorSchemeSchema.optional(),
  layout: TestimonialLayoutSchema.optional(),
  logoEnabled: z.boolean().optional(),
  headerTextEnabled: z.boolean().optional(),
  preheaderEnabled: z.boolean().optional(),
  nameCreditEnabled: z.boolean().optional(),
  ctaEnabled: z.boolean().optional(),
  style: z
    .object({
      backgroundColor: z.string().optional(),
    })
    .optional(),
});

export const TestimonialBlockConfigSchema = z.object({
  options: TestimonialOptionsSchema,
  type: z.literal(BlockType.Testimonial),
  fieldGroups: z.tuple([TestimonialFieldGroupSchema]).rest(TestimonialFieldGroupSchema),
  version: z.literal(1),
});
